export default "__VITE_ASSET__WImZFiB___"